import { Box, Text, Toggle, type ToggleContainer } from '@stitch-fix/mode-react';
import { ReactNode, useState } from 'react';
type ToggleContainerData = Parameters<ToggleContainer>[0];
interface GalleryOptInOutToggleProps {
  onChange: (value: boolean) => void;
  isOptedIn: boolean;
  footerContent?: ReactNode;
}
const GalleryOptInOutToggle = ({
  onChange,
  isOptedIn,
  footerContent
}: GalleryOptInOutToggleProps) => {
  const [selected, setIsSelected] = useState(isOptedIn);
  const handleToggle = (value: boolean) => {
    setIsSelected(value);
    onChange(value);
  };
  return <Box>
      <Toggle isSelected={selected} data-testid={`gallery-toggle-opted-${isOptedIn ? 'in' : 'out'}`} onChange={handleToggle} container={(data: ToggleContainerData) => <Box mt={3} mb={2} style={{
      display: 'flex',
      gap: '1rem'
    }}>
            <Box>{data.toggleUi}</Box>
            <Box>
              <Text setting="title-xxsmall">
                <strong>Get fresh Vision images weekly</strong>
              </Text>
              <Text mt={0.5} setting="body-small">
                Ready for more? <strong>Vision</strong> will add new images to
                your gallery every week.
              </Text>
            </Box>
          </Box>} />
      {footerContent ? <Box mt={2}>{footerContent}</Box> : null}
    </Box>;
};
export default GalleryOptInOutToggle;